<template lang="pug">
.container.mx-auto.px-6.text-center
  p.font-bold.text-acn-green.text-xl.relative.z-20.mb-8 Videos
  transition(name='quick-fade', appear, mode='out-in') 
    .mx-auto.text-center(v-if='!loading')
      div(v-for='v of videos' :key='v.id').mb-16
        p.text-xl.font-black {{v.title}}
        template(v-if='v.video')
        .sixteen-nine.my-4(v-if='v.video[0].videoLink').xl_mx-32
          .content
            iframe(width="100%" height="100%" :src="v.video[0].videoLink" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)
        .max-w-xl.mx-auto.mt-10
          .redactor(v-html='v.mainText').text-acn-green
          
          .flex.space-x-8.justify-center.mb-10.mt-1
            p.text-xl.font-light {{v.video[0].by}}
            a(:href='v.video[0].source' target='_blank').hover_border-acn-green.hover_text-acn-green.border-b.border-black.text-xl.font-light(v-if='v.video[0].source') {{v.video[0].sourceTitle || v.video[0].source}}
</template>

<script>
import gql from 'graphql-tag'
import { apiQL } from '@/api'

export default {
  name: 'Videos',
  data() {
    return {
      videos: [],
    }
  },
  computed: {
    loading() {
      return this.$store.state.loading
    },
  },
  watch: {},
  created() {
    this.$store.commit('loading', true)
    this.loadItem()
  },
  mounted() {
    document.body.className = 'bg-acn-green-light'
  },
  methods: {
    async loadItem() {
      console.log('dag')

      this.$store.commit('loading', true)

      try {
        const q = gql`
          query {
            entries(type: "video") {
              id
              title
              ... on videos_video_Entry {
                mainText
                video {
                  videoLink
                  by
                  source
                  sourceTitle
                }
              }
            }
          }
        `
        const result = await apiQL(q)

        console.log(result)
        this.videos = result.data.entries
      } catch (error) {
        console.log(error)
        this.error = error
      }

      this.$store.commit('loading', false)
    },
  },
  metaInfo() {
    const title = this.page ? this.page.title : ''
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title,
      meta: [
        {
          vmid: 'og:title',
          content: title,
        },
      ],
    }
  },
}
</script>

<style lang="stylus" scoped>
.sixteen-nine {
  position: relative;

}
.sixteen-nine:before {
  display: block;
  content: "";
  width: 100%;
  padding-top: 56.25%;
}
.sixteen-nine > .content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
